import React from 'react'
import { Icon } from '@iconify/react';
import Div from '../Div';

export default function SocialWidget() {
  return (
    <Div className="cs-social_btns cs-style1">
      <a href='https://turderhoffnung.com' target='_blank' rel='noreferrer' className="cs-center">
        <Icon icon="mdi:web" />
      </a>
      <a href='/contact' className="cs-center">
        <Icon icon="mdi:map-marker" />
      </a>
      <a href='/payment' className="cs-center">
        <Icon icon="mdi:credit-card-outline" />
      </a>
      <a href='https://turderhoffnung.com/contact' target='_blank' rel='noreferrer' className="cs-center">
        <Icon icon="mdi:help-circle-outline" />
      </a>
    </Div>
  )
}
